import { Fragment } from "react";
import React from 'react';
import { CnButton, Box, Grid, formilyReact } from '@alife/cn-ui';
import ReactionItemArrayForm from "./reaction-item-array-form";
import ConditionArrayForm from "./condition-array-form";
var FormProvider = formilyReact.FormProvider,
  ArrayField = formilyReact.ArrayField,
  useField = formilyReact.useField,
  observer = formilyReact.observer;
var ArrayComponent = observer(function (_ref) {
  var _field$value;
  var span = _ref.span;
  var field = useField();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Grid.Row, {
      key: index,
      style: {
        width: '100%',
        padding: '10px 0',
        margin: 0,
        borderBottom: '1px solid #e7e8ed'
      },
      align: 'top',
      gutter: 8
    }, /*#__PURE__*/React.createElement(Grid.Col, {
      span: span[0]
    }, /*#__PURE__*/React.createElement(ConditionArrayForm, {
      name: index + ".conditions"
    })), /*#__PURE__*/React.createElement(Grid.Col, {
      span: span[1]
    }, /*#__PURE__*/React.createElement(ReactionItemArrayForm, {
      name: index + ".reaction"
    })), /*#__PURE__*/React.createElement(Grid.Col, {
      span: span[2]
    }, /*#__PURE__*/React.createElement(CnButton, {
      style: {
        height: '32px'
      },
      warning: true,
      onClick: function onClick() {
        field.remove(index);
      }
    }, "\u5220\u9664")));
  }), /*#__PURE__*/React.createElement(CnButton, {
    size: 'small',
    type: 'primary',
    style: {
      width: '100%',
      marginTop: '10px'
    },
    onClick: function onClick() {
      field.push({
        reaction: [{}]
      });
    }
  }, "\u65B0\u589E\u6761\u4EF6")));
});
export default (function (_ref2) {
  var _ref2$span = _ref2.span,
    span = _ref2$span === void 0 ? [10, 10, 4] : _ref2$span,
    form = _ref2.form,
    name = _ref2.name;
  if (!Box || !Grid || !(Grid !== null && Grid !== void 0 && Grid.Row) || !(Grid !== null && Grid !== void 0 && Grid.Row)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FormProvider, {
    form: form
  }, /*#__PURE__*/React.createElement(ArrayField, {
    name: name,
    component: [ArrayComponent, {
      span: span
    }]
  }));
});